export interface Product {
  id: string;
  categoryId: string;
  subCategoryId: string;
  title: string;
  model: string;
  image: string;
  tags: string[];
  desc: string;
}

export interface SubCategory {
  id: string;
  label: string;
}

export interface Category {
  id: string;
  label: string;
  en: string;
  icon: string;
  subCategories: SubCategory[];
}

export const categories: Category[] = [
  {
    id: 'enclosure',
    label: '空箱・接線箱・控制箱',
    en: 'Enclosures & Junction Boxes',
    icon: 'ri-box-3-line',
    subCategories: [
      { id: 'stainless', label: '不銹鋼 防水 防爆 空箱' },
      { id: 'grp', label: 'GRP 空箱・接線箱' },
      { id: 'aluminum', label: '鋁合金防爆箱' },
    ],
  },
  {
    id: 'transformer',
    label: '變壓器',
    en: 'Transformers',
    icon: 'ri-flashlight-line',
    subCategories: [
      { id: 'ex-transformer', label: '防爆變壓器' },
      { id: 'general-transformer', label: '一般型變壓器' },
    ],
  },
  {
    id: 'explosion-proof',
    label: '防爆設備',
    en: 'Explosion-Proof Equipment',
    icon: 'ri-fire-line',
    subCategories: [
      { id: 'ex-junction', label: '防爆接線箱' },
      { id: 'ex-switch', label: '防爆開關控制箱' },
      { id: 'ex-panel', label: '防爆操作面板' },
    ],
  },
  {
    id: 'medical',
    label: '醫療用品',
    en: 'Medical Supplies',
    icon: 'ri-first-aid-kit-line',
    subCategories: [
      { id: 'eyewash', label: '洗眼器' },
    ],
  },
  {
    id: 'cable-gland',
    label: '固定頭',
    en: 'Cable Glands',
    icon: 'ri-plug-line',
    subCategories: [
      { id: 'cable-gland-standard', label: '電纜固定頭' },
      { id: 'cable-gland-anti-twist', label: '耐扭式電纜固定頭' },
      { id: 'cable-gland-conduit', label: '浪管固定頭' },
      { id: 'cable-gland-accessories', label: '配件' },
    ],
  },
];

export const products: Product[] = [
  // 不銹鋼 防水 防爆 空箱
  {
    id: 'ss-001',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: 'SS304 防水接線箱（壁掛型）',
    model: 'SS304-IP66-W',
    image: '/images/photo02_bg.png',
    tags: ['IP66', 'SS304', 'NEMA 4X'],
    desc: '304不銹鋼材質，IP66防水防塵等級，適用於戶外及腐蝕性環境。',
  },
  {
    id: 'ss-002',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: 'SS316L 防爆接線箱（EExe）',
    model: 'SS316-EExe-JB',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExe', 'SS316L', 'IP65'],
    desc: '316L不銹鋼，符合ATEX認證，適用於Zone 1/Zone 2危險區域。',
  },
  {
    id: 'ss-003',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: '不銹鋼控制箱（含鎖及鉸鏈）',
    model: 'SS304-CB-HL',
    image: '/images/photo02_bg.png',
    tags: ['IP65', 'SS304', '含鎖具'],
    desc: '附不銹鋼鉸鏈及三點鎖，適合工業控制系統安裝使用。',
  },
  {
    id: 'ss-004',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: '掛壁式不銹鋼控制箱',
    model: 'SS304-WM-CB',
    image: '/images/photo02_bg.png',
    tags: ['IP66', 'SS304', '掛壁式'],
    desc: '掛壁式安裝設計，門板可180°開啟，內置安裝板。',
  },
  {
    id: 'ss-005',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: '落地式不銹鋼配電箱',
    model: 'SS304-FS-PD',
    image: '/images/photo02_bg.png',
    tags: ['IP54', 'SS304', '落地式'],
    desc: '落地型大尺寸配電箱，適合工廠配電室及電氣室使用。',
  },
  {
    id: 'ss-006',
    categoryId: 'enclosure',
    subCategoryId: 'stainless',
    title: '防水壁掛型接線箱（小型）',
    model: 'SS304-IP67-SM',
    image: '/images/photo02_bg.png',
    tags: ['IP67', 'SS304', '小型'],
    desc: 'IP67高防水等級，小型尺寸，適用於感測器及儀表接線。',
  },
  // GRP 空箱
  {
    id: 'grp-001',
    categoryId: 'enclosure',
    subCategoryId: 'grp',
    title: 'GRP 防水接線箱（標準型）',
    model: 'GRP-IP65-STD',
    image: '/images/photo02_bg.png',
    tags: ['IP65', 'GRP', '耐腐蝕'],
    desc: '玻璃纖維強化聚酯材質，輕量耐腐蝕，適合海岸及化工環境。',
  },
  {
    id: 'grp-002',
    categoryId: 'enclosure',
    subCategoryId: 'grp',
    title: 'GRP 防爆接線箱（ATEX認證）',
    model: 'GRP-ATEX-JB',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'IP66', 'GRP', 'EExe'],
    desc: '通過ATEX防爆認證，GRP材質，適用於Zone 1/2石化廠場域。',
  },
  {
    id: 'grp-003',
    categoryId: 'enclosure',
    subCategoryId: 'grp',
    title: 'GRP 落地型控制箱',
    model: 'GRP-FS-CB',
    image: '/images/photo02_bg.png',
    tags: ['IP55', 'GRP', '落地式'],
    desc: '落地型GRP控制箱，內置安裝板及電纜進線孔，適合戶外安裝。',
  },
  {
    id: 'grp-004',
    categoryId: 'enclosure',
    subCategoryId: 'grp',
    title: 'GRP 多門配電箱',
    model: 'GRP-MD-PD',
    image: '/images/photo02_bg.png',
    tags: ['IP65', 'GRP', '多門'],
    desc: '雙門或多門設計，適合大型工業配電系統整合需求。',
  },
  // 鋁合金防爆箱
  {
    id: 'alu-001',
    categoryId: 'enclosure',
    subCategoryId: 'aluminum',
    title: '鋁合金防爆接線箱（EExd）',
    model: 'AL-EExd-JB',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', '鋁合金', 'IP66'],
    desc: '壓鑄鋁合金，EExd隔爆型，通過ATEX/IECEx雙認證，適用Zone 1。',
  },
  {
    id: 'alu-002',
    categoryId: 'enclosure',
    subCategoryId: 'aluminum',
    title: '鋁合金防爆控制箱',
    model: 'AL-EExd-CB',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', '鋁合金'],
    desc: '大尺寸鋁合金防爆控制箱，含深型蓋板，適合儀表或端子台安裝。',
  },
  // 防爆變壓器
  {
    id: 'ext-001',
    categoryId: 'transformer',
    subCategoryId: 'ex-transformer',
    title: 'EExe 防爆變壓器 200VA',
    model: 'EExe-TX-200VA',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExe', '200VA', 'IP65'],
    desc: '增安型防爆，200VA容量，適用控制電路用途，Zone 1/2認證。',
  },
  {
    id: 'ext-002',
    categoryId: 'transformer',
    subCategoryId: 'ex-transformer',
    title: 'EExd 防爆隔離變壓器 500VA',
    model: 'EExd-IT-500VA',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', '500VA', 'IP66'],
    desc: '隔爆型防爆，500VA，一次側/二次側可依需求客製電壓規格。',
  },
  {
    id: 'ext-003',
    categoryId: 'transformer',
    subCategoryId: 'ex-transformer',
    title: 'EExe 控制電路變壓器 1KVA',
    model: 'EExe-CT-1KVA',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExe', '1KVA'],
    desc: '1KVA大容量控制電路用變壓器，防爆鋁合金外殼，耐衝擊設計。',
  },
  // 一般型變壓器
  {
    id: 'gnt-001',
    categoryId: 'transformer',
    subCategoryId: 'general-transformer',
    title: '單相隔離變壓器 200VA',
    model: 'IT-1P-200VA',
    image: '/images/photo02_bg.png',
    tags: ['單相', '200VA', '隔離型'],
    desc: '單相隔離變壓器，銅線圈，低溫升設計，適合精密儀器供電。',
  },
  {
    id: 'gnt-002',
    categoryId: 'transformer',
    subCategoryId: 'general-transformer',
    title: '三相自藕變壓器 2KVA',
    model: 'AT-3P-2KVA',
    image: '/images/photo02_bg.png',
    tags: ['三相', '2KVA', '自藕型'],
    desc: '三相自藕式，效率高、體積小，適合馬達啟動及電壓轉換用途。',
  },
  {
    id: 'gnt-003',
    categoryId: 'transformer',
    subCategoryId: 'general-transformer',
    title: '精密儀器用隔離變壓器',
    model: 'IT-PREC-500VA',
    image: '/images/photo02_bg.png',
    tags: ['精密型', '500VA', 'IP20'],
    desc: '靜電屏蔽設計，有效抑制雜訊干擾，適用於精密電子儀器電源供應。',
  },
  // 防爆接線箱
  {
    id: 'exj-001',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-junction',
    title: '防爆接線箱 EExd II（小型）',
    model: 'EExd-JB-SM',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', 'Zone 1', 'IP66'],
    desc: '小型隔爆型接線箱，壓鑄鋁合金，適合石化廠Zone 1危險區域。',
  },
  {
    id: 'exj-002',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-junction',
    title: '防爆接線箱 EExe（增安型）',
    model: 'EExe-JB-MD',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExe', 'Zone 2', 'IP65'],
    desc: '增安型防爆接線箱，適用Zone 2，含端子台及電纜夾，安裝方便。',
  },
  // 防爆開關控制箱
  {
    id: 'exs-001',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-switch',
    title: '防爆電源開關控制箱',
    model: 'EExd-SW-CB',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', '含開關', 'IP66'],
    desc: '內含隔離開關及斷路器，防爆鋁合金外殼，符合ATEX認證規範。',
  },
  {
    id: 'exs-002',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-switch',
    title: '防爆馬達控制中心（MCC）',
    model: 'EExd-MCC-01',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', 'MCC', 'Zone 1'],
    desc: '防爆型馬達控制中心，含啟動器及保護繼電器，適合大型工廠應用。',
  },
  // 防爆操作面板
  {
    id: 'exp-001',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-panel',
    title: '防爆操作面板（按鈕型）',
    model: 'EExd-OP-BTN',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExd', '按鈕', 'IP66'],
    desc: '含緊急停止及啟動按鈕，防爆隔爆型，適合危險區域現場操作。',
  },
  {
    id: 'exp-002',
    categoryId: 'explosion-proof',
    subCategoryId: 'ex-panel',
    title: '防爆HMI操作面板',
    model: 'EExe-HMI-7IN',
    image: '/images/photo02_bg.png',
    tags: ['ATEX', 'EExe', 'HMI', '7吋'],
    desc: '7吋觸控式HMI，增安型防爆外殼，適用Zone 2工廠自動化系統。',
  },
];
